import { motion } from "framer-motion";
import { WasteAssessmentForm } from "@/components/WasteAssessmentForm";
import { BRAND, IMAGES } from "@/lib/site";
import { Phone, Mail, MapPin } from "lucide-react";

export default function Contact() {
  return (
    <>
      <section className="pt-36 pb-12 px-4 sm:px-6 lg:px-8 border-b border-dc-border dc-grid-lines">
        <div className="max-w-[1400px] mx-auto">
          <span className="dc-label">Waste Value Assessment</span>
          <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }} className="font-display uppercase tracking-tighter text-5xl sm:text-6xl lg:text-7xl font-semibold leading-[0.92] mt-6 max-w-4xl">
            Assess Your Waste Stream
          </motion.h1>
          <p className="mt-6 max-w-2xl text-dc-text2 leading-relaxed">Designed for organisations generating commercial quantities of recyclable material. Complete the assessment and our commercial team will identify the strongest commercially viable route for your recovered material.</p>
        </div>
      </section>

      <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="dc-label mb-4">Talk to our commercial team</div>
            <p className="text-dc-text2 leading-relaxed mb-8">Discuss bulk paper, cardboard, OCC, recovered-fibre supply, off-take or logistics partnerships.</p>
            <div className="space-y-4 mb-10">
              <a href={BRAND.phoneHref} data-testid="contact-phone" className="flex items-center gap-3 text-white hover:text-dc-accent transition-colors"><Phone size={18} className="text-dc-accent" /> <span className="font-mono text-lg">{BRAND.phone}</span></a>
              <a href={`mailto:${BRAND.email}`} data-testid="contact-email" className="flex items-center gap-3 text-white hover:text-dc-accent transition-colors"><Mail size={18} className="text-dc-accent" /> <span className="font-mono break-all">{BRAND.email}</span></a>
              <div className="flex items-center gap-3 text-dc-text2"><MapPin size={18} className="text-dc-accent" /> {BRAND.location}</div>
            </div>
            <div className="relative aspect-[4/3] overflow-hidden border border-dc-border">
              <img src={IMAGES.london} alt="London" className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-dc-bg/30" />
            </div>
            <div className="mt-6 border border-dc-border p-4 bg-dc-surface">
              <div className="text-[11px] uppercase tracking-wider text-dc-text2">Registered Upper Tier Waste Broker</div>
              <div className="font-mono text-dc-accent mt-1">{BRAND.eaReg}</div>
            </div>
          </div>
          <div className="lg:col-span-8">
            <WasteAssessmentForm />
          </div>
        </div>
      </section>
    </>
  );
}
